module.exports = __webpack_public_path__ + "static/ISO_9001-3a9efa892ec1d14011282cfcf46ae6c0.svg";